import { Strings } from '../../generated/strings';
import { Rpc } from '../rpc';
import { RpcType } from '../rpc-base';
import { RpcInbound } from '../rpc-inbound';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcUpdateData, RpcUpdateDataKey } from './rpc-update-data-model';

export class RpcUpdateDataClient {
    /**
     * The update data command.
     *
     * @param name the module name.
     * @param subName the sub name of module.
     * @param data the update data object.
     * @return Promise<void> the promise object.
     */
    public static updateData(rpc: Rpc, name: string, subName: string, data: RpcUpdateData): Promise<void> {
        const rpcInbound = rpc.rpcManager.rpcChannel.getRpc<RpcInbound>(name, subName, RpcType.Inbound);
        if (rpcInbound) {
            return RpcInboundClient.call(rpc, RpcUpdateDataKey.command, RpcUpdateDataKey.version, data);
        }

        const message = MsftSme.getStrings<Strings>().MsftSmeShell.Core.Error.RpcNotFountInbound.message;
        return Promise.reject(message.format(name, subName));
    }
}
